import axios from "axios";
import { useEffect, useState } from "react";
import Header from "../../../components/Header";
import BangCauTX from "../../../components/BangCauTX"; 
import swal from "sweetalert";
import { GetNameChoose } from "../../../../funcUtils";
import chen from "./../img/chen.png";
import dia from "./../img/dia.png";
import "../../XDia/xd.css";
import "./../tx.css";

function TX45s() {
    const SANH_ID = 5; 

    const [isVisible, setVisible] = useState(null);
    const [bet, setBet] = useState(null);
    const [profile, setProfile] = useState(null);
    const [historyGame, setHistoryGame] = useState(null);
    const [second, setSecond] = useState(45);
    const [minute, setMinute] = useState(0);
    const [start, setStart] = useState(false);
    const [dulieunhap, setDulieunhap] = useState(new Date());
    const [update, setUpdate] = useState(0);
    const date = new Date();
    const currentMinute = date.getMinutes();
    const currentSecond = date.getSeconds();
    const [total, setTotal] = useState(null);
    const [total2, setTotal2] = useState(null);
    const [setting, setSetting] = useState(null);
    const [isShow, setShow] = useState(false);
    const [ls, setLs] = useState(null);
    const [newMoney, setNewMoney] = useState(null);
    const [message, setMessage] = useState(null);
    const [share, setShare] = useState(false);
    const [choose, setChoose] = useState([]);

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const [activeOption, setActiveOption] = useState(null);

    const handleOptionClick = (option) => {
        setActiveOption(option); 
        const currentMoney = newMoney ? Number(String(newMoney).replaceAll(".", "").replaceAll(",", "")) : 0;
        const addMoney = Number(option) * 1000;
        const totalMoney = currentMoney + addMoney;
        setNewMoney(totalMoney.toLocaleString("vi-VN"));
    };

    // 🔥 HÀM DỊCH MÃ CƯỢC TÀI XỈU 
    const getBetLabel = (stateStr) => {
        if (!stateStr) return "";
        const map = { "1": "CHẴN", "2": "LẺ", "3": "TÀI", "4": "XỈU" };
        return String(stateStr).split(" ").map(s => map[s] || s).join(", ");
    };

    useEffect(() => {
        let pointEl = document.querySelector(".point");
        if(pointEl) pointEl.style.animation = "movePointBack2 0.1s forwards";

        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {}).then((res) => {
            setProfile(res.data.data);
        });

        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
            if(res.data && res.data.data) setSetting(res.data.data[0]);
        });

        axios.get(`${process.env.REACT_APP_API_URL}/tx45s/get?sanh=${SANH_ID}`).then((res) => {
            if(res.data && res.data.data) {
                const data = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
                if(data) {
                    setBet(data);
                    setDulieunhap(new Date(data.createdAt));
                    setStart(true);
                }
            }
        });

        axios
            .get(`${process.env.REACT_APP_API_URL}/tx45s/getallbet?sanh=${SANH_ID}`, {})
            .then((res) => {
                setTotal(res.data.data);
                setTotal2(res.data.data);
            })
            .catch(() => setTotal(null));
            
        getHistoryBet();
        getProfile();
    }, []);

    useEffect(() => {
        const timer = setInterval(() => {
            if (Math.floor(45 - (new Date() - dulieunhap) / 1000) < 0) {
                axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {}).then((res) => {
                    setProfile(res.data.data);
                });
                
                axios.get(`${process.env.REACT_APP_API_URL}/tx45s/get?sanh=${SANH_ID}`).then((res) => {
                    if(res.data && res.data.data) {
                        const data = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
                        if(data) {
                            setBet(data);
                            setDulieunhap(new Date(data.createdAt));
                        }
                    }
                });

                axios
                    .get(`${process.env.REACT_APP_API_URL}/tx45s/getallbet?sanh=${SANH_ID}`, {})
                    .then((res) => {
                        setTotal(res.data.data);
                        setTotal2(res.data.data);
                    })
                    .catch(() => setTotal(null));
                    
                getHistoryBet();
                getProfile();
            }
        }, 500);

        return () => clearInterval(timer);
    }, [dulieunhap]);

    useEffect(() => {
        let curTime_second = Math.floor(45 - (date - dulieunhap) / 1000);

        let myTimeout;

        if (currentMinute === dulieunhap.getMinutes() && currentSecond === dulieunhap.getSeconds()) {
            setStart(true);
            setSecond(second - 1);
            return () => { clearTimeout(myTimeout); };
        } else if (curTime_second < 45 && curTime_second >= 0) {
            setSecond(curTime_second);
            setMinute((curTime_second - (curTime_second % 60)) / 60);
            setStart(true);
            return () => { clearTimeout(myTimeout); };
        } else {
            myTimeout = setTimeout(() => { setUpdate(update + 1); }, 500);
        }
    }, [update, dulieunhap]);

    useEffect(() => {
        let curTime_second = Math.floor(45 - (date - dulieunhap) / 1000);
        let myTimeout = 0;
        if (start) {
            setSecond(curTime_second);
            setMinute(Math.floor(curTime_second / 60));

            if (curTime_second > 45 || curTime_second <= 0) {
                setStart(false);
                setMinute(0);
                setSecond(45);
                return () => { clearTimeout(myTimeout); };
            }
            myTimeout = setTimeout(() => { setSecond(second - 1); }, 1000);
        }
        return () => { clearTimeout(myTimeout); };
    }, [second, start, dulieunhap]);

    function onChoose(num) {
        if ((choose.includes("6") && num === "5") || (choose.includes("5") && num === "6")) {
            //swal("Thông báo", "Không được phép đặt 2 cửa", "warning");
        }
        if (choose.includes(num)) {
            setChoose(choose.filter((item) => item !== num));
        } else {
            setChoose([...choose, num]);
        }
    }

    const onSubmit = (e) => {
        e.preventDefault();
        if (newMoney == 0 || newMoney == null) {
            swal("Thất bại", "Bạn chưa nhập tiền", "error");
            return;
        }
        const formData = {
            result: choose.join(" "),
            id: bet?._id,
            money: choose.length * Number(newMoney.replaceAll(".", "").replaceAll(",", "")),
            sanh: SANH_ID 
        };
        if (profile && formData.money > profile.money) {
            swal("Thất bại", "Số dư không đủ", "error");
            return;
        }
        if (Number(second) <= 10 && Number(minute) == 0) {
            swal("Đã hết thời gian cược", "Vui lòng chờ phiên tiếp theo", "info");
            return;
        }
        if (choose.length == 0) {
            swal("Thất bại", "Bạn chưa lựa chọn", "error");
            return;
        } else {
            axios
                .post(`${process.env.REACT_APP_API_URL}/history/chooseTX45s`, formData)
                .then((res) => {
                    swal({ title: "Đặt cược thành công", icon: "success" });
                    setChoose([]);
                    getHistoryBet();
                    getProfile();
                })
                .catch((err) => swal("Đã xảy ra lỗi", "Vui lòng tải lại trang", "error"));
        }
    };

    function formatDate(m) {
        if (!m) return "";
        const d = new Date(m);
        return d.getFullYear() + "/" +
            ("0" + (d.getMonth() + 1)).slice(-2) + "/" +
            ("0" + d.getDate()).slice(-2) + "  " +
            ("0" + d.getHours()).slice(-2) + ":" +
            ("0" + d.getMinutes()).slice(-2);
    }

    const [activeTab, setActiveTab] = useState("tab1");
    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
        getHistoryBet();
    };

    function getHistoryBet() {
        axios
            .get(`${process.env.REACT_APP_API_URL}/history/historyus`, { params: { keyword: "TX45s", sanh: SANH_ID } })
            .then((res) => {
                if(res.data && res.data.data) setHistoryGame(res.data.data);
            })
            .catch((err) => function () {});
    }

    function getProfile() {
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {}).then((res) => {
            if(res.data && res.data.data) setProfile(res.data.data);
        });
    }

    const [datcuoc, setDatcuoc] = useState(false);
    const [dungcuoc, setDungcuoc] = useState(false);
    const [trathuong, setTrathuong] = useState(false);

    useEffect(() => {
  if (bet) {
   let pointEl = document.querySelector(".point");
   let checkEl = document.querySelector(".check");

   if (Number(second) === 1) {
    if(pointEl) pointEl.style.animation = "movePoint2 4s forwards";
    if(checkEl) checkEl.style.animation = "";
   } else if (Number(second) === 40) {
    if(pointEl) pointEl.style.animation = "movePointBack2 4s forwards";
    getHistoryBet();
    getProfile();
    setDatcuoc(true);
    setTimeout(function () { setDatcuoc(false); }, 3000);
   } else if (Number(second) === 10) {
    setDungcuoc(true);
    setTimeout(function () { setDungcuoc(false); }, 3000);
   } else if (Number(second) === 8) {
    if(pointEl) pointEl.style.animation = "shake 4s forwards";
   } else if (Number(second) === 4) {
    if(checkEl) checkEl.style.animation = "";
   } else if (Number(second) === 0) {
    setTrathuong(true);
    setTimeout(function () { setTrathuong(false); }, 3000);
   }
  }
 }, [second, bet]);

    return (
        <>
            <div className="main tx">
                <Header profile={profile} />
                <div className="box-bg-game">
                    <div className="bg-game">
                        <div style={{ 
                            position: "absolute", 
                            top: "3px", 
                            left: "15px",
                            width: "100%", 
                            textAlign: "center",
                            fontSize: "26px", 
                            fontWeight: "bold", 
                            color: "#FFD700", 
                            textTransform: "uppercase",
                            zIndex: 10,
                            pointerEvents: "none" 
                        }}>
                            Sảnh E
                        </div>
                        <div data-v-45adac70="" className="v_circle taste_lottery_countdown xodi  v_circle_show v_circle_PC">
                            <div data-v-45adac70="" className="mask full">
                                {second >= 23 && <div data-v-45adac70="" className="fill fix_l" style={{ transform: `rotate(${180 - (45 - second) * 8}deg)` }}></div>}
                            </div>
                            <div data-v-45adac70="" className="mask half">
                                {second < 23 ? (
                                    <div data-v-45adac70="" className="fill fix" style={{ transform: `rotate(${second * 8}deg)` }}></div>
                                ) : (
                                    <div data-v-45adac70="" className="fill fix" style={{ transform: `rotate(180deg)` }}></div>
                                )}
                            </div>
                            <div data-v-45adac70="" flex="main:center cross:center" className="pv">
                                <span data-v-45adac70="" className="progress">
                                    {second}
                                </span>
                            </div>
                        </div>
                        <div className="boxdia">
                            <img alt="" src={chen} className="point" style={{ animation: "movePointBack2" }} />
                            <img alt="" className="check" src={dia} />
                            {total && total.length > 0 && total[0]?.result && (
                                <div className="history_tx result-dia">
                                    {total[0].result.trim().split(" ").map((item, i) => (
                                        <div key={i} className={`a${item}`}></div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className="timexd">
                            <span style={{ fontSize: "0.4rem" }}>Phiên {bet?.id_bet}</span> <br />
                            <span style={{ opacity: "0.7" }}>{bet ? formatDate(new Date(bet.createdAt)) : null}</span>
                        </div>
                        {dungcuoc && (
                            <div className="game-noti dungcuoc">
                                <img src={require("../../XDia/img/noti-dungcuoc.png")} alt="Dừng cược" />
                            </div>
                        )}
                        {datcuoc && (
                            <div className="game-noti datcuoc">
                                <img src={require("../../XDia/img/noti-datcuoc.png")} alt="Bắt đầu cược" />
                            </div>
                        )}
                        {trathuong && (
                            <div className="game-noti trathuong">
                                <img src={require("../../XDia/img/noti-trathuong.png")} alt="Trả thưởng" />
                            </div>
                        )}
                    </div>
                </div>

                <div className="box-button-choose">
                    <button className={`taste_unit_item ${choose.includes("1") ? "active" : ""}`} onClick={(e) => onChoose("1")}>
                        <div className="taste_unit_img taste_unit_img_SHUANG"></div>
                        <div className="taste_unit_odds">{setting && setting.tx_c}</div>
                    </button>
                    <button className={`taste_unit_item ${choose.includes("2") ? "active" : ""}`} onClick={(e) => onChoose("2")}>
                        <div className="taste_unit_img taste_unit_img_DAN"></div>
                        <div className="taste_unit_odds">{setting && setting.tx_l}</div>
                    </button>
                    <button className={`taste_unit_item ${choose.includes("3") ? "active" : ""}`} onClick={(e) => onChoose("3")}>
                        <div className="taste_unit_img taste_unit_img_DA"></div>
                        <div className="taste_unit_odds">{setting && setting.tx_t}</div>
                    </button>
                    <button className={`taste_unit_item ${choose.includes("4") ? "active" : ""}`} onClick={(e) => onChoose("4")}>
                        <div className="taste_unit_img taste_unit_img_XIAO"></div>
                        <div className="taste_unit_odds">{setting && setting.tx_x}</div>
                    </button>
                </div>

                <div className="bet_taste_chips">
                    <div data-v-331b32c3="" className={`taste_chips_swiper_item ${activeOption === "5" ? "active" : ""}`} onClick={() => handleOptionClick("5")}>
                        <div data-v-331b32c3="" flex="main:center cross:center" className="taste_chip">
                            <div data-v-331b32c3="" className="taste_chip_base taste_chip_10">
                                <div data-v-331b32c3="" className="item_chip_num">
                                    <span data-v-331b32c3="">5K</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div data-v-331b32c3="" className={`taste_chips_swiper_item ${activeOption === "10" ? "active" : ""}`} onClick={() => handleOptionClick("10")}>
                        <div data-v-331b32c3="" flex="main:center cross:center" className="taste_chip">
                            <div data-v-331b32c3="" flex="main:center cross:center" className="taste_chip_base taste_chip_25">
                                <div data-v-331b32c3="" className="item_chip_num">
                                    <span data-v-331b32c3="">10K</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div data-v-331b32c3="" className={`taste_chips_swiper_item ${activeOption === "50" ? "active" : ""}`} onClick={() => handleOptionClick("50")}>
                        <div data-v-331b32c3="" className="taste_chip">
                            <div data-v-331b32c3="" className="taste_chip_base taste_chip_50">
                                <div data-v-331b32c3="" className="item_chip_num">
                                    <span data-v-331b32c3="">50K</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div data-v-331b32c3="" className={`taste_chips_swiper_item ${activeOption === "100" ? "active" : ""}`} onClick={() => handleOptionClick("100")}>
                        <div data-v-331b32c3="" className="taste_chip">
                            <div data-v-331b32c3="" className="taste_chip_base taste_chip_100">
                                <div data-v-331b32c3="" className="item_chip_num">
                                    <span data-v-331b32c3="">100K</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div data-v-331b32c3="" className={`taste_chips_swiper_item ${activeOption === "500" ? "active" : ""}`} onClick={() => handleOptionClick("500")}>
                        <div data-v-331b32c3="" className="taste_chip">
                            <div data-v-331b32c3="" className="taste_chip_base taste_chip_200">
                                <div data-v-331b32c3="" className="item_chip_num">
                                    <span data-v-331b32c3="">500K</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div data-v-331b32c3="" className={`taste_chips_swiper_item ${activeOption === "1000" ? "active" : ""}`} onClick={() => handleOptionClick("1000")}>
                        <div data-v-331b32c3="" className="taste_chip">
                            <div data-v-331b32c3="" className="taste_chip_base taste_chip_500">
                                <div data-v-331b32c3="" className="item_chip_num">
                                    <span data-v-331b32c3="">1000K</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div data-v-331b32c3="" className={`taste_chips_swiper_item ${activeOption === "5000" ? "active" : ""}`} onClick={() => handleOptionClick("5000")}>
                        <div data-v-331b32c3="" className="taste_chip">
                            <div data-v-331b32c3="" className="taste_chip_base taste_chip_5">
                                <div data-v-331b32c3="" className="item_chip_num">
                                    <span data-v-331b32c3="">5000K</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bet-input-panel bet_panel_taste">
                    <div data-v-331b32c3="" flex="main:justify box:justify cross:center" className="bet_taste_info">
                         <button
                            data-v-331b32c3=""
                            className="bet_taste_reset"
                            onClick={() => {
                                setActiveOption(null);
                                setNewMoney(""); 
                                setChoose([]);   
                            }}>
                            Đặt lại
                        </button>
                        <div data-v-331b32c3="" className="bet_taste_text">
                            <div data-v-331b32c3="" flex="main:center cross:center" className="bet_taste_num vi">
                                <span data-v-331b32c3="" className="bet_taste_text__common">
                                    Đã chọn
                                </span>
                                <span data-v-331b32c3="" className="bet_taste_text__protrude">
                                    {choose ? choose.length : 0}
                                </span>
                                <span data-v-331b32c3="" className="bet_taste_text__common">
                                    Lô
                                </span>
                            </div>
                            <div data-v-331b32c3="" flex="cross:center" className="bet_taste_money">
                                <input
                                    data-v-331b32c3=""
                                    flex-box="8"
                                    className="bet_taste_money_bet"
                                    min={1000}
                                    value={newMoney || ""}
                                    onChange={(e) => setNewMoney(e.target.value)}
                                    onClick={() => setActiveOption(null)}
                                    onKeyUp={(e) => setNewMoney(Number(e.target.value.replaceAll(".", "").replaceAll(",", "")).toLocaleString("vi-VN"))}
                                    name="money"
                                    type="text"
                                    placeholder="Nhập số tiền"
                                />
                            </div>
                        </div>
                        <button data-v-331b32c3="" className="bet_taste_submit" type="submit" onClick={onSubmit}>
                            Đặt cược
                        </button>
                    </div>
                </div>

                <div className="bangcau-wrapper" style={{ marginTop: "15px", marginBottom: "20px" }}>
                    <BangCauTX dataHistory={total} />
                </div>

                <div className="history_game">
                    <ul className="tab-navigation">
                        <li className={activeTab === "tab1" ? "active" : ""} onClick={() => handleTabClick("tab1")}>
                            Lịch sử trò chơi
                        </li>
                        <li className={activeTab === "tab2" ? "active" : ""} onClick={() => handleTabClick("tab2")}>
                            Lịch sử của tôi
                        </li>
                    </ul>

                    <div className="tab-content">
                        {activeTab === "tab1" && (
                            <div className="award_tb">
                                <table>
                                    <thead style={{ textAlign: "center" }}>
                                        <tr>
                                            <td>Phiên</td>
                                            <td>Kết quả</td>
                                            <td>Thời gian</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{bet && bet.id_bet}</td>
                                            <td style={{ textAlign: "center", color: "#ed6c02" }}>Đang chờ kết quả</td>
                                            <td>{bet && formatDate(new Date(bet.createdAt))}</td>
                                        </tr>
                                        {total2 &&
                                            total2.map((item, index) => (
                                                <tr key={index}>
                                                    <td style={{ textAlign: "center" }}>{item?.id_bet}</td>
                                                    <td
                                                        className="history_tx"
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center"
                                                        }}>
                                                        {item.result && item.result.trim().split(" ").map((r, i) => (
                                                            <div key={i} className={`a${r}`}></div>
                                                        ))}
                                                    </td>
                                                    <td style={{ textAlign: "center" }}>{formatDate(new Date(item.createdAt))}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {activeTab === "tab2" && (
                            <>
                                {historyGame != null && historyGame.length > 0 ? (
                                    <div className="content-history award_tb">
                                        {historyGame?.map((item, key) => (
                                            <div key={key}>
                                                {item.sanh === SANH_ID || item.sanh === `Sảnh E` || Number(item.sanh) === SANH_ID ? (
                                                    <div
                                                        className="item_inner"
                                                        style={{ padding: "5px" }}
                                                        onClick={() => {
                                                            setLs(item);
                                                            setShow(true);
                                                        }}>
                                                        <div className="item_history">
                                                            <div className="title_item_history">
                                                                <span className="sanh" style={{ color: "#f5f5f5" }}>
                                                                    Sảnh E
                                                                </span>
                                                                <span
                                                                    className={`type_state text_status ${
                                                                        item.status_bet === "Pending" ? "pending" : item.status_bet === "Win" ? "win" : "lose"
                                                                    }`}>
                                                                    {item.status_bet === "Pending" ? "Chờ xổ" : item.status_bet === "Win" ? "Thắng" : "Thua"}
                                                                </span>
                                                            </div>
                                                            <div className="id_history_sanh">Phiên: {item?.id_bet?.id_bet ? item?.id_bet?.id_bet : item?.id_bet}</div>
                                                        
                                                            <div className="id_history_sanh" style={{ color: "#ffc107", fontWeight: "bold" }}>Chọn: {getBetLabel(item.state)}</div>
                                                        </div>
                                                        <div className="money_history">
                                                            <span className="money" style={{ color: "#28a745", fontWeight: "bold" }}>
                                                                {Number(item.money).toLocaleString("vi-VN")} đ
                                                            </span>
                                                            <div className="time_choose">{formatDate(new Date(item.createdAt))}</div>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div style={{ padding: "20px", textAlign: "center" }}>Chưa có lịch sử cược</div>
                                )}
                            </>
                        )}
                    </div>
                </div>

                {isShow === true && ls && ls.status_bet !== "Pending" ? (
    <div className="modal" style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999999
    }}>
        <div className="modaloverlay" 
            onClick={() => setShow(false)} 
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                cursor: "pointer"
            }}
        ></div>

        <div className="modalbody" style={{
            position: "relative",
            zIndex: 10,
            backgroundColor: "#ffffff", 
            color: "#000000",
            borderRadius: "8px",
            width: "90%",
            maxWidth: "350px",
            padding: "15px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.5)"
        }}>
            <div className="modalinner">
                <div className="modalheader" style={{ paddingBottom: "15px", textAlign: "center", fontSize: "18px", fontWeight: "bold", borderBottom: "1px solid #333", marginBottom: "15px" }}>
                    Chi tiết cược
                </div>
                {ls?.id_bet?.id_bet ? (
                    <>
                        <div className="lsgd-table" style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                            <span>Trò chơi</span>
                            <span>Tài xỉu 45s (Sảnh E)</span>
                        </div>
                        <div className="lsgd-table" style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                            <span>Phiên</span>
                            <span>{ls?.id_bet?.id_bet}</span>
                        </div>
                        <div className="lsgd-table" style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                            <span>Thời gian</span>
                            <span>{formatDate(new Date(ls.createdAt))}</span>
                        </div>
                        <div className="lsgd-table" style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                            <span>Đặt cược</span>
                            <span style={{ color: "#d32f2f", fontWeight: "bold" }}>{getBetLabel(ls.state)}</span>
                        </div>
                        <div className="lsgd-table" style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                            <span>Tổng đặt</span>
                            <span>{Number(ls.money).toLocaleString("vi-VN")} đ</span>
                        </div>
                        <div className="lsgd-table" style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px" }}>
                            <span>Tổng thắng</span>
                            <span style={{ color: "#28a745", fontWeight: "bold" }}>{Number(ls.moneythang).toLocaleString("vi-VN")} đ</span>
                        </div>

                        <div style={{ textAlign: "center", fontSize: "14px", margin: "10px 0" }}>Kết quả phiên {ls?.id_bet?.id_bet}</div>
                        <div className="history_tx" style={{ display: "flex", justifyContent: "center", gap: "5px", marginBottom: "15px" }}>
                            {ls.id_bet.result && ls.id_bet.result.trim().split(" ").map((item, i) => (
                                <div key={i} className={`a${item}`}></div>
                            ))}
                        </div>
                    </>
                ) : null}

                <div className="modalformcontrols">
                    <button
                        onClick={() => setShow(false)}
                        className="popup-close"
                        style={{
                            background: "#0064ff",
                            color: "#fff",
                            border: "none",
                            width: "100%",
                            padding: "12px",
                            borderRadius: "5px",
                            fontWeight: "bold",
                            cursor: "pointer"
                        }}>
                        ĐÓNG
                    </button>
                </div>
            </div>
        </div>
    </div>
) : null}
            </div>
        </>
    );
}
export default TX45s;